// extracted by mini-css-extract-plugin
export default {"cantBuy":"ListView_cantBuy__ecW2+"};